import { useCnpjRules } from "@hooks/useCnpjRules";

/**
 * Componente invisível que sincroniza a feature flag de CNPJ alfanumérico
 * com o config global. Deve ser montado no App.tsx para garantir que
 * todas as páginas (incluindo as sem Header) respeitem a flag.
 */
const CnpjConfigSync: React.FC = () => {
  useCnpjRules();
  return null;
};

export default CnpjConfigSync;
